import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from "interfaces/paginate-duck";
import { IScheduleOrderFOB } from "interfaces/order-fob";

const { Types, Creators } = createActions(
  {
    request: ["query"],
    success: ["data", "pagination"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "PAGINATE_SCHEDULED_ORDERS_FOB" }
);

export interface PaginateScheduledOrdersFOBState extends IState {
  data: IScheduleOrderFOB[];
}

const INITIAL_STATE: PaginateScheduledOrdersFOBState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: PaginateScheduledOrdersFOBState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: PaginateScheduledOrdersFOBState, action: ISuccessAction) => 
  update(state, {
    data: { $set: action.data as IScheduleOrderFOB[] },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (state: PaginateScheduledOrdersFOBState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const paginateScheduledOrdersFOB = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginateScheduledOrdersFOBTypes = Types;
export const PaginateScheduledOrdersFOBActions = Creators;
